import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet';



import Inperson from '../../pics/web_development_bootcamp_barcelona_code_school.jpg'

const JSBDP = () => (

	<div className="white grid-1-3"
	>
	<Helmet

	title="Web / Mobile Development Bootcamp payments page"
	meta={[
		{ name: 'description', content: 'BCS Payments page' },
		{ name: 'keywords', content: 'payment form' },
		{ name: 'viewport', content: 'width=device-width, initial-scale=1' }
		]}
			/>
			<div>
			<h1>Web / Mobile Development Bootcamp in Barcelona Code School</h1>
			<h2>Payment form: 10% fee paid</h2>
			</div>

			<div style={{
				marginTop: '2em',

			}}>
			<img 
			className='banners'
			src={Inperson} 
			alt='Web / Mobile Development Bootcamp in Barcelona Code School'/>

			</div>



			

			<h2 id="cohorts">Access</h2>
			<div>
			<div className="event" >
			<h4>5220€</h4>
			<span>
			<h2>Tuition payment</h2>
			</span>
			<span>
			<p>10% registration paid</p>
			<Link to="/register" state={{course: "Web / Mobile Development Bootcamp, payment #2", date:'According to contract', cost:5220, images: ["http://barcelonacodeschool.com/files/pics/web_development_bootcamp_barcelona_code_school.jpg"]}}>
			<button>Proceed to checkout</button>
			</Link>
			</span>
			</div>
			
		

			
			</div>




			</div>


			)

export default JSBDP
